//helpers
import { getDomainConfig } from 'shared/domainConfig/helpers';
// import { IProductList } from 'shared/layouts/DetailsPage/components/Widgets/types';

interface DomainConfig {
  [key: string]: string;
}

export enum DEVICE_TYPE {
  DESKTOP = 'WEBSITE',
  MOBILE = 'MSITE',
}

let deviceType: DEVICE_TYPE = DEVICE_TYPE.MOBILE;

export const setDeviceType = (newDeviceType: DEVICE_TYPE) => {
  deviceType = newDeviceType;
};

export const getDeviceType = () => deviceType;

// Lazy initialization to avoid calling getDomainConfig at module import time
let domainConfigCache: ReturnType<typeof getDomainConfig> | null = null;

const getDomainConfigCached = () => {
  if (!domainConfigCache) {
    domainConfigCache = getDomainConfig();
  }
  return domainConfigCache;
};

// For testing: reset the cache
export const __resetDomainConfigCache = () => {
  domainConfigCache = null;
};

const DOMAIN_CONFIG: DomainConfig = {
  NYKAA_FASHION: 'NYKAA_FASHION',
  FOOT_LOCKER: 'FOOT_LOCKER',
};

export const getDomain = () => {
  const { API } = getDomainConfigCached();
  return DOMAIN_CONFIG[API.DOMAIN_PARAM];
};

export const getOldDomain = () => {
  const { API_OLD } = getDomainConfigCached();
  return API_OLD.DOMAIN_PARAM;
};

// export const modifyStoreURL = (redirectToHome: boolean, product: IProductList, url: string) => {
//   if(redirectToHome){
//     // Switcher, PLP Banner, Navbar, Search Suggestion Banner
//     return;
//   }
//   // Wishlist -> PDP
//   // Get existing store
//   const existingStoreType = 
//   if(product.storeRedirection !== existingStoreType){
//     window.location.href = modified url
//   }else{
//     // push to same url
//   }

// };